export default "__VITE_ASSET__516d2988__"